(function () {
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
  
      const btn = target.closest('[data-unit]');
      if (!btn) return;
  
      const toggle = btn.closest('[data-unit-toggle]');
      if (!toggle) return;
  
      const unit = btn.getAttribute('data-unit') || 'in';
      const hidden = toggle.querySelector('input[type="hidden"]');
      if (hidden) {
        hidden.value = unit;
      }
  
      // Update active state
      toggle.querySelectorAll('[data-unit]').forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        el.classList.toggle('unit-toggle__btn--active', el === btn);
      });
  
      // Dispatch a global event so pages can react (e.g. cfg-wizard, product pages)
      const detail = {
        name: hidden ? hidden.name : '',
        unit,
      };
      document.dispatchEvent(new CustomEvent('unit-toggle:change', { detail }));
    });
  })();
  
  